import { CubeIcon } from '@fronton/icons-react';
import { DesignRegistrationPanelStructure } from 'common/components/design-registration-panel';

export const KITCHEN_PANEL_STRUCTURE: DesignRegistrationPanelStructure = {
  panel: {
    content: {
      leftIcon: CubeIcon,
      iconColor: 'accent-primary',
      iconType: 'duotone',
      text: `Запишитесь на\u00A0проектирование или рассчитайте примерную стоимость кухни в\u00A0нашем калькуляторе`,
    },
    actionBlock: [],
  },
  mobilePanel: {
    content: {
      icon: CubeIcon,
      iconColor: 'accent-primary',
      iconType: 'duotone',
      text: `Запишитесь на\u00A0проектирование или рассчитайте примерную стоимость кухни в\u00A0нашем калькуляторе`,
    },
    mobileButton: {
      elementBlock: 'landingProektKuhni',
      openModal: true,
      label: 'Записаться на проектирование',
    },
    actionBlock: [],
  },
};
